import "./style.scss";

type SkeletonProps = {
	length: number;
	className?: string;
	height?: number;
	width?: number;
	borderRadius?: number;
};

export const Skeleton = ({
	length,
	className,
	height,
	width,
	borderRadius,
}: SkeletonProps) => {
	return Array.from({ length }).map((_, key) => {
		return (
			<div
				className={`skeleton ${className}`}
				style={{ height, width, borderRadius }}
				key={key}
			></div>
		);
	});
};

export default Skeleton;
